import { FaVolumeUp } from "react-icons/fa";
import style from "./AlphabetCard.module.scss";

interface LetterData {
	letter?: string;
	transliteratedLetter?: string;
	sound?: string;
	image?: string;
}

const AlphabetCard: React.FC<LetterData> = ({
	letter,
	transliteratedLetter,
	sound,
	image,
}) => {
	const handlePlayAudio = () => {
		if (sound) {
			const audio = new Audio(sound);
			audio.play();
		}
	};

	return (
		<div className={style.alphabetCard}>
			{image ? (
				<img src={image} alt={`Card of ${letter || transliteratedLetter}`} />
			) : (
				<div className={style.letterLearned}>{letter}</div>
			)}
			<div className={style.letterInfo}>
				<p className={style.transliteration}>
					{image ? (
						<span className={style.letter}>
							{letter} ({transliteratedLetter})
						</span>
					) : (
						<span>{transliteratedLetter}</span>
					)}
				</p>
			</div>
			{sound && (
				<button
					type="button"
					className={style.playButton}
					onClick={handlePlayAudio}
				>
					<FaVolumeUp />
				</button>
			)}
		</div>
	);
};

export default AlphabetCard;
